module.exports = __webpack_public_path__ + "img/flag.c3811f31.svg";